// extracted by mini-css-extract-plugin
export var menuIcon = "_tu-0";
export var menuIconInline = "_tu-1";